import Rest from '@/services/Rest';

/**
 * @typedef {ContractService}
 */
export default class ContractService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/contract'

  blob(params) {
    return this.post('/export', params, { responseType: 'blob' });
  }
}
